import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import UsersIcon from '../../assets/Users.svg';
import './InvitedMembersModal.css';
import { useI18n } from '../../i18n';

const InvitedMembersModal = ({
    isOpen,
    onClose,
    team,
    invites,
    loading,
    onResend,
    onCancel,
    hasMore,
    loadingMore,
    onLoadMore,
}) => {
    const { t } = useI18n();
    const [actionLoading, setActionLoading] = useState(null);

    const handleListScroll = (e) => {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 50) {
            if (!loadingMore && hasMore && onLoadMore) {
                onLoadMore();
            }
        }
    };

    if (!isOpen || !team) return null;

    const getAvatarColor = (str) => {
        const colors = [
            '#6366F1', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981',
            '#3B82F6', '#EF4444', '#14B8A6', '#F97316', '#6B7280'
        ];
        const index = str ? str.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    const handleResend = async (inviteId) => {
        setActionLoading(inviteId);
        try {
            await onResend(inviteId);
        } finally {
            setActionLoading(null);
        }
    };

    const handleCancel = async (inviteId) => {
        setActionLoading(inviteId);
        try {
            await onCancel(inviteId);
        } finally {
            setActionLoading(null);
        }
    };

    const pendingCount = invites.filter(i => i.status === 'pending').length;
    const totalCount = invites.length;

    return (
        <div className="invited-members-modal-overlay" onClick={onClose}>
            <div className="invited-members-modal" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="team-modal-header">
                    <h2 className="team-modal-title">{t('pages.teams.invited_members')}</h2>
                    <button
                        className="team-modal-close"
                        onClick={onClose}
                        aria-label={t('common.actions.close')}
                    >
                        <FaTimes />
                    </button>
                </div>

                {/* Body */}
                <div className="invited-members-modal-body">
                    {loading ? (
                        <div className="invited-members-loading">{t('common.status.loading')}</div>
                    ) : invites.length === 0 ? (
                        <div className="invited-members-empty">{t('pages.teams.no_invites_found')}</div>
                    ) : (
                        <>
                            <div className="invited-members-list-header">
                                <img src={UsersIcon} alt="" className="invited-members-icon" />
                                <span>{t('pages.teams.invites_summary', { pending: pendingCount, total: totalCount })}</span>
                            </div>

                            <div className="invited-members-list" onScroll={handleListScroll}>
                                {invites.map((invite) => (
                                    <div key={invite.id} className="invited-member-row">
                                        <div className="invited-member-info">
                                            <div className="invited-member-info-container">
                                                <div
                                                    className="invited-member-avatar"
                                                    style={{ backgroundColor: getAvatarColor(invite.email) }}
                                                >
                                                    {invite.email?.charAt(0)?.toUpperCase() || '?'}
                                                </div>
                                                <div className="invited-member-details">
                                                    <div className="invited-member-email">{invite.email}</div>
                                                    <div className="invited-member-meta">
                                                        {t('pages.teams.labels.role')}: {invite.role || t('pages.teams.labels.member')}
                                                        {invite.inviter && ` - ${t('pages.teams.invited_by', { name: invite.inviter.name })}`}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="invited-member-actions">
                                            <span className={`invite-status-badge ${invite.status}`}>
                                                {t(`pages.teams.statuses.${invite.status}`)}
                                            </span>

                                            {invite.status !== 'accepted' && (
                                                <>
                                                    <button
                                                        className="invite-action-btn resend"
                                                        onClick={() => handleResend(invite.id)}
                                                        disabled={actionLoading === invite.id}
                                                    >
                                                        {actionLoading === invite.id ? '...' : t('common.actions.resend')}
                                                    </button>
                                                    <button
                                                        className="invite-action-btn cancel"
                                                        onClick={() => handleCancel(invite.id)}
                                                        disabled={actionLoading === invite.id}
                                                    >
                                                        {t('common.actions.cancel')}
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                ))}
                                {loadingMore && (
                                    <div className="invited-members-loading-more">{t('common.status.loading')}</div>
                                )}
                            </div>
                        </>
                    )}
                </div>
                {/* Footer */}
                <div className="team-modal-footer">
                    <button
                        type="button"
                        className="team-modal-btn team-btn-secondary"
                        onClick={onClose}
                    >
                        {t('common.actions.cancel')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InvitedMembersModal;
